module.exports = __webpack_public_path__ + "static/media/discover.40c9db94.jpg";